import styled from 'styled-components'

export const Wrapper = styled.div`
  color: var(--ui-red);
  font-size: 14px;
  font-weight: var(--font-medium);
  margin-top: 12px;
  line-height: 16px;
`
